export function formatDollar(value) {
    const options = {
        style: 'currency',
        currency: 'USD',
        trailingZeroDisplay: 'stripIfInteger'
    };
    const formater = new Intl.NumberFormat('en-US', options);
    return formater.format(value);
}
export function formatNumberWithCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
